// src/pages/ContactPage.jsx
import React, { useState } from 'react';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        const errors = {};
        const strictMessageRegex = /^[a-zA-Z0-9\s.,!?'"()+\-:;@#$%&*=/\\[\]{}|~`^_]+$/;

        if (!formData.email.includes('@')) errors.email = 'Valid email required';
        if (!formData.name.match(/^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/)) errors.name = 'Name required';
        if (!formData.message.trim()) errors.message = 'Message is required';
        if (formData.message.trim().length < 10) errors.message = 'Message must be at least 10 characters';
        if (formData.message.length > 2000) errors.message ='Message is too long';
        if (!strictMessageRegex.test(formData.message)) errors.message = 'Message contains invalid characters';
        setFormErrors(errors);
        return Object.keys(errors).length === 0; // true = valid
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;  // your validation
        //setSubmitted(true);

        try {
            const form = e.target;
            const formData = new FormData(form);

            await fetch('/', {  // ← MUST BE '/' for Netlify
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(formData).toString(),
            });

            setSubmitted(true);
            setFormData({ name: '', email: '', message: '' });
            setFormErrors({});
        } catch (error) {
            console.error('Submission error:', error);
            alert('Oops! Something went wrong. Please try again.');
        } finally {
            setSubmitted(false);
        }
    };

    return (
        <div className="contact-page">
            <div className="container">
                <h1>Contact Us</h1>
                <p className="contact-intro">
                    Have questions about Zenzzz, sleep science, or anything in between? We’re here to help.
                    Send us a message and we’ll get back to you as soon as possible.
                </p>

                {submitted && (
                    <div className="modal-overlay" onClick={() => setSubmitted(false)}>
                        <div className="modal success-modal" onClick={e => e.stopPropagation()}>
                            <h2>Thank You!</h2>
                            <p>Your message has been sent successfully.</p>
                            <p>We’ll get back to you within 24 hours.</p>
                            <button onClick={() => setSubmitted(false)} className="cta-button">
                                Close
                            </button>
                        </div>
                    </div>
                )}


                <form
                    name="contact"
                    method="POST"
                    data-netlify="true"
                    netlify-honeypot="bot-field"
                    onSubmit={handleSubmit}
                    className="contact-form"
                >
                    <input type="hidden" name="form-name" value="contact" />
                    <input type="hidden" name="email" value={formData.email} />
                    <p style={{ display: 'none' }}>
                        <label>Don’t fill this out: <input name="bot-field" /></label>
                    </p>

                    <div className="form-group">
                        <div className={`input-group ${formErrors.name ? 'invalid' : ''}`}>
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            value={formData.name}
                            onChange={handleChange}
                            noValidate
                        />
                            {formErrors.name && <div className="error-tooltip">{formErrors.name}</div>}
                        </div>
                    </div>

                    <div className="form-group">
                        <div className={`input-group ${formErrors.email ? 'invalid' : ''}`}>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            value={formData.email}
                            onChange={handleChange}
                            noValidate
                        />
                            {formErrors.email && <div className="error-tooltip">{formErrors.email}</div>}
                        </div>

                    </div>

                    <div className="form-group">
                        <div className={`input-group ${formErrors.message ? 'invalid' : ''}`}>
                        <label htmlFor="message">Message</label>
                        <textarea
                            name="message"
                            id="message"
                            rows="6"
                            value={formData.message}
                            onChange={handleChange}
                            noValidate
                        />
                            {formErrors.message && <div className="error-tooltip">{formErrors.message}</div>}
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="cta-button large"
                        onClick={(e) => {
                            if (validateForm()){
                                e.preventDefault();
                                // Submit the hidden Netlify form
                                document.querySelector('form[name="contact"]').submit();
                                alert('Your message has been sent successfully. We’ll get back to you within 24 hours.');

                            }
                        }}

                    >
                        Send Message
                    </button>
                </form>

                <div className="contact-info">
                    <p>Or email us directly: <a href="mailto:support@zenzzz.online">support@zenzzz.online</a></p>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;